'use client'

import { useEffect, useState } from 'react'
import { buildAttributedUrl } from '@/lib/attribution'

/**
 * A CTA <a> whose href picks up page/CTA/UTM attribution once mounted on the
 * client. Renders the plain base URL for SSR/first paint (so there's no
 * hydration mismatch), then swaps in the attributed URL via useEffect.
 */
export function AttributedCtaLink({
  href,
  page,
  cta,
  children,
  className,
  target,
  rel,
  onClick,
}: {
  href: string
  page: string
  cta: string
  children: React.ReactNode
  className?: string
  target?: string
  rel?: string
  onClick?: () => void
}) {
  const [resolvedHref, setResolvedHref] = useState(href)

  useEffect(() => {
    setResolvedHref(buildAttributedUrl(href, { page, cta }))
  }, [href, page, cta])

  return (
    <a href={resolvedHref} target={target} rel={rel} className={className} onClick={onClick}>
      {children}
    </a>
  )
}
